import React from 'react';
import LoadingButton from '../../../../components/LoadingButton';
import LoadingPage from '../../../sheard/LoadingPage';

const CustomerGeneralModal = ({customerGeneralModalInfo,title,setPayAmount,handlePaymentRequest,loading}) => {

    return (
        <div>
            {/* The button to open modal */}
{/* <label htmlFor="customerGeneralModal" className="btn">open modal</label> */}

{/* Put this part before </body> tag */}
<input type="checkbox" id="customerGeneralModal" className="modal-toggle" />
<label htmlFor="customerGeneralModal" className="modal cursor-pointer">
  <label className="modal-box relative" htmlFor="">
    <h3 className="text-lg text-center font-bold">{title}</h3>
    <div>
    <div className='flex flex-col gap-3'>
  <h2 className="font-bold">
                          আইডি : {customerGeneralModalInfo?.customerId}
                        </h2>
                        <h2 className="font-bold">
                          গ্রাকের নাম : {customerGeneralModalInfo?.customerName}
                        </h2>
                        <h2>
                          মাসিক ফি :{" "}
                          <span className="font-black">
                            {customerGeneralModalInfo?.monthlyFee}
                          </span>
                        </h2>
                        <h2>
                          বকেয়া :{" "}
                          <span className="font-black">
                            {customerGeneralModalInfo?.stupidity}{" "}
                          </span>{" "}
                        </h2>
  </div>
  <div className="divider"></div>
  <div className='flex flex-col gap-3'>
  <input onChange={(e)=>setPayAmount(e.target.value)} type="number" placeholder="টাকা" className="input input-bordered w-full " />
  { loading ? <LoadingPage title={"পরিশোধ"}></LoadingPage> :
    <input onClick={()=>handlePaymentRequest(customerGeneralModalInfo._id)} type="submit" value={"পরিশোধ"} className="btn btn-ghost outline outline-gray-300 w-full " />
  }
 
  </div>
    </div>
  </label>
</label>
        </div>
    );
};

export default CustomerGeneralModal;